import { render } from "./Action.vue?vue&type=template&id=3ff7da78&scoped=true"
import script from "./Action.vue?vue&type=script&lang=ts"
export * from "./Action.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3ff7da78"

export default script
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QInput});
